export default __webpack_public_path__ + "static/media/icons-system-search-close.4065a01c.svg";